"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var calculate_bundle_price_1 = __importDefault(require("./calculate-bundle-price"));
exports.default = (function (items) { return items.reduce(function (sum, item) { return sum + (item.children ? (0, calculate_bundle_price_1.default)(item) : item.item.price * item.item.quantity); }, 0); });
